export default "__VITE_ASSET__DmCGv5L0__"